import { useCallback, useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import { Link } from "react-router-dom";
import "../blogs/admin_blog.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 

const blogDeleteEndpoint = ApiEndpoints.AIBlogs.AIBlogDelete;
const blogListEndpoint = ApiEndpoints.AIBlogs.AIBlogList;
const blogEditPath = "edit-ai-blog";
const tableHeader = ["Title", "Author"];
const tbody = ["name","author_name"];

export default function AIBlogs() {

  const [data, setData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", blogListEndpoint);
      const result = response.aiblogs;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  }, []);


  useEffect(() => {
    dataFetch();
  }, [dataFetch]);


  const handleDelete = useCallback(
    async (aiblog_id) => {
      const payload = { aiblog_id };
      try {
        await ApiRequest("POST", blogDeleteEndpoint, payload);
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    },
    [dataFetch]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>AI Blogs</h5>
      </div>
      <div className="add-blog-section">
        <Link className="default-btn" to="/admin/add-ai-blog">
          add ai blog
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={blogEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
